import { render, staticRenderFns } from "./PMChartPCTable.vue?vue&type=template&id=f855d694&"
import script from "./PMChartPCTable.vue?vue&type=script&lang=ts&"
export * from "./PMChartPCTable.vue?vue&type=script&lang=ts&"
import style0 from "./PMChartPCTable.vue?vue&type=style&index=0&id=f855d694&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports